import { type Theme } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { colors } from '@procore/core-react';

export const useStyles = makeStyles((theme: Theme) => ({
  container: {
    padding: '22px 18px 18px 18px',
    borderRadius: '5px',
    boxShadow: '0 0 4px 0 rgba(0, 0, 0, 0.25)',
    [theme.breakpoints.down(1100)]: {
      width: 'calc(50% - 12px)',
      marginRight: '12px',
      border: '1px solid ' + colors.gray85,
      boxShadow: 'none',
    },
    [theme.breakpoints.down(600)]: {
      width: '100%',
      marginRight: 0,
    },
  },
  isNdaProject: {
    [theme.breakpoints.down(750)]: {
      width: '100%',
      marginRight: 0,
    },
  },
  title: {
    marginBottom: '6px',
    fontWeight: 600,
  },
  getInTouch: {
    marginBottom: '12px',
    color: colors.gray45,
    fontSize: '14px',
    fontWeight: 400,
  },
  businessContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  businessLogo: {
    '& > div': {
      height: '50px',
      minHeight: '50px',
      width: '50px',
      minWidth: '50px',
      '& > img': {
        borderRadius: '3px',
      },
    },
  },
  businessNameAndLink: {
    marginLeft: '12px',
  },
  businessName: {
    marginBottom: '4px',
    lineHeight: '18px',
  },
  businessLink: {
    color: colors.blue45,
    fontSize: '14px',
    fontWeight: 400,
  },
  buttonContainer: {
    display: 'block',
    marginTop: '12px',
    paddingTop: '12px',
    borderTop: '1px solid ' + colors.gray85,
    [theme.breakpoints.down(600)]: {
      //borderTop: 'none',
    },
  },
  disableButtonContainer: {
    pointerEvents: 'none',
  },
  button: {
    width: '100%',
  },
  biddingClosed: {
    marginTop: '10px',
    color: colors.gray45,
    fontSize: '12px',
    fontWeight: 400,
  },
}));
